import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-cash',
    templateUrl: './checkout-payment-cash.page.html',
    styleUrls: ['./checkout-payment-cash.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutPaymentCashPage implements OnInit {

    payment = {
        method: 'cash',
        price: null,
        label: 'Cash'
    };

    cart = null;
    payment_amount = null
    change = 0;
    adding_payment = false;

    amount_due_rounded = null;
    cash_rounding_direction = null;
    cash_rounding_mode = '';
    cash_rounding_price = 0;
    cash_rounding_difference = 0;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
    ) { }

    ngOnInit() {
        this.cartService.get().then((cart) => {
            if(cart) {
                this.cart = cart;
                if(cart['currency'].cash_rounding_mode) {
                    this.cash_rounding_mode = cart['currency'].cash_rounding_mode;
                }
                this.calculateCashRounding();
            }
        });
    }

    calculateCashRounding() {

        this.cash_rounding_price = 0;
        this.cash_rounding_difference = 0;

        let amount_due_last_digit = Number(new Decimal(this.cart.amount_due).minus(new Decimal(this.cart.amount_due).floor()).toDecimalPlaces(2).toFixed(2).slice(-1));
        let amount_due_last_digit_decimal = amount_due_last_digit / 100;

        if(this.cash_rounding_mode == '5_intervals_always_round_down' || this.cash_rounding_mode == '5_intervals_round_to_nearest' || this.cash_rounding_mode == '5_intervals_always_round_up') {

            if(amount_due_last_digit_decimal != 0.00 && amount_due_last_digit_decimal != 0.05) {

                if(this.cash_rounding_mode == "5_intervals_always_round_down") {

                    this.cash_rounding_direction = "-";

                    if(amount_due_last_digit_decimal < 0.05) {
                        this.cash_rounding_difference = amount_due_last_digit_decimal;
                    }
                    else if(amount_due_last_digit_decimal > 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(amount_due_last_digit_decimal).minus(new Decimal(0.05)).toDecimalPlaces(2));
                    }

                }
                else if(this.cash_rounding_mode == "5_intervals_round_to_nearest") {

                    if(amount_due_last_digit_decimal == 0.01 || amount_due_last_digit_decimal == 0.02) {
                        this.cash_rounding_direction = "-";
                        this.cash_rounding_difference = amount_due_last_digit_decimal;
                    }
                    else if(amount_due_last_digit_decimal == 0.03 || amount_due_last_digit_decimal == 0.04) {
                        this.cash_rounding_direction = "+";
                        this.cash_rounding_difference = Number(new Decimal(0.05).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal == 0.06 || amount_due_last_digit_decimal == 0.07) {
                        this.cash_rounding_direction = "-";
                        this.cash_rounding_difference =  Number(new Decimal(amount_due_last_digit_decimal).minus(new Decimal(0.05)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal == 0.08 || amount_due_last_digit_decimal == 0.09) {
                        this.cash_rounding_direction = "+";
                        this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }

                }
                else if(this.cash_rounding_mode == "5_intervals_always_round_up") {

                    this.cash_rounding_direction = "+";

                    if(amount_due_last_digit_decimal < 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(0.05).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }
                    else if(amount_due_last_digit_decimal > 0.05) {
                        this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                    }

                }

            }
        }
        else if(this.cash_rounding_mode == '10_intervals_round_down_at_5' || this.cash_rounding_mode == '10_intervals_round_up_at_5') {
            
            if (amount_due_last_digit_decimal != 0.00) {

                if(amount_due_last_digit_decimal <= 0.04) {
                    this.cash_rounding_direction = "-";
                    this.cash_rounding_difference = amount_due_last_digit_decimal;
                }
                else if(amount_due_last_digit_decimal == 0.05) {

                    this.cash_rounding_difference = 0.05;

                    if(this.cash_rounding_mode == "10_intervals_round_down_at_5") {
                        this.cash_rounding_direction = "-";
                    }
                    else if(this.cash_rounding_mode == "10_intervals_round_up_at_5") {
                        this.cash_rounding_direction = "+";
                    }

                }
                else if(amount_due_last_digit_decimal >= 0.06) {
                    this.cash_rounding_direction = "+";
                    this.cash_rounding_difference = Number(new Decimal(0.10).minus(new Decimal(amount_due_last_digit_decimal)).toDecimalPlaces(2));
                }

            }
        }

        this.cash_rounding_price = this.cash_rounding_difference;

        // ensure negative values are passed correctly
        if(this.cash_rounding_direction == '-') {
            this.cash_rounding_price = Number(new Decimal(this.cash_rounding_difference).times(-1).toDecimalPlaces(2));
        }

        this.amount_due_rounded = Number(new Decimal(this.cart.amount_due).plus(new Decimal(this.cash_rounding_price)).toDecimalPlaces(2));

    }    

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

        this.calculateChange();

    }

    addPredefinedAmount(amount) {
        if(this.payment.price == null) {
            this.payment.price = 0;
        }
        this.payment.price = Number(new Decimal(this.payment.price).plus(new Decimal(amount)).toDecimalPlaces(2));
        this.payment_amount = this.payment.price;
        this.calculateChange();
    }

    calculateChange() {

        if(this.payment.price) {

            this.change = Number(new Decimal(this.payment.price).minus(new Decimal(this.amount_due_rounded)).toDecimalPlaces(2));

            if(this.change < 0) {
                this.change = 0;
            }
        }
        else {
            this.change = 0;
        }
    }

    enterPressed() {

        // NOTE: only add the payment when the add payment button would be shown
        if(this.payment.price > 0) {
            this.addPayment();
        }

    }

    addPayment() {

        // NOTE: ignore repeat presses while the payment is being added, otherwise a double tap/Enter adds it twice
        if(!this.adding_payment) {

            this.adding_payment = true;

            // ensure payment isn't over the amount due
            if(this.payment.price > this.amount_due_rounded) {
                this.payment.price = this.amount_due_rounded;
            }

            this.cartService.addPayment(this.payment).then(() => {
                if(this.payment.price == this.amount_due_rounded) {
                    this.cartService.updateCashRoundingPrice(this.cash_rounding_price).then(() => {
                        this.modalController.dismiss();
                    });
                }
                else {
                    this.modalController.dismiss();
                }
            })
            .catch(() => {
                this.adding_payment = false;
            });

        }
    }

    close() {
        this.modalController.dismiss();
    }

}
